module.exports = "./img/f061d055a7b8eccd773acafa1276ae7e.jpg";